import React from 'react';
import {useSelector} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import PopupFullPage from '../../../components/Popup/PopupFullPage';
import * as reconnectGuideTypes from '../../../consts/app/reconnectGuideTypes';
import ModalTypes from '../../../enums/app/modalTypes';
import {hideModalAction} from '../../../state/ducks/modal';
import {makeSelectIotDeviceFullData} from '../../../state/selectors/consumer';
import {makeLoaders} from '../../../state/selectors/global';
import {dispatch} from '../../../state/store';
import objUtils from '../../../utils/objUtils';
import CriticalReconnectGuide from './components/CriticalReconnectGuide';
import NotCriticalReconnectGuide from './components/NotCriticalReconnectGuide';
import ReconnectGuideComponent from './components/ReconnectGuideComponent';
import reconnectDeviceGuidePopupService from './reconnectDeviceGuidePopupService';

const selector = createStructuredSelector({
    iotDevice: makeSelectIotDeviceFullData(),
    loaders: makeLoaders(),
});

const ReconnectDeviceGuidePopup = (props) => {
    const {guideType} = props;
    const {iotDevice, loaders} = useSelector(selector);
    const {device} = iotDevice || {};
    const isAnyLoader = loaders?.length > 0;
    const {type: deviceType} = device || {};
    const guideDataList = reconnectDeviceGuidePopupService.getReconnectListData(deviceType);
    const {reconnectData, notCriticalReconnectData, criticalReconnectData} = guideDataList || {};

    let guideData;
    let GuideComponent;

    switch (guideType) {
        case reconnectGuideTypes.REGULAR:
            GuideComponent = ReconnectGuideComponent;
            guideData = reconnectData || {};
            break;
        case reconnectGuideTypes.NOT_CRITICAL:
            GuideComponent = NotCriticalReconnectGuide;
            guideData = notCriticalReconnectData || {};
            break;
        case reconnectGuideTypes.CRITICAL:
            GuideComponent = CriticalReconnectGuide;
            guideData = criticalReconnectData || {};
            break;
        default:
            break;
    }

    const isGuideDataNotEmpty = !objUtils.isAnyKeys(guideData);

    const hideModalGuide = () => {
        dispatch(hideModalAction(ModalTypes.RECONNECT_DEVICE_GUIDE));
    };

    if (isGuideDataNotEmpty || isAnyLoader || !GuideComponent) {
        hideModalGuide();
    }

    return (
        <PopupFullPage>
            <GuideComponent guideData={guideData} hideModalGuide={hideModalGuide} />
        </PopupFullPage>
    );
};

export default ReconnectDeviceGuidePopup;
